import { Env } from "@/constants";
import axios, { type InternalAxiosRequestConfig } from "axios";
import { authStore } from "../stores";
import { toast } from "sonner";

export const createUrl = (path: string) => {
  if (import.meta.env.MODE === "development") {
    return Env.NEXT_PUBLIC_BASE_URL_DEV + path;
  } else if (import.meta.env.MODE === "production") {
    return Env.NEXT_PUBLIC_BASE_URL_PROD + path;
  } else {
    return Env.NEXT_PUBLIC_BASE_URL_STG + path;
  }
};

const axiosClient = axios.create({
  responseType: "json",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

axiosClient.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const { authToken, language } = authStore.getState();
    if (authToken) {
      config.headers.set("Authorization", `Bearer ${authToken}`);
    }
    if (language) {
      config.headers.set("Content-Language", language); // ID / EN
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  (response) => {
    // console.log("[Axios] response.success", response);
    return response;
  },
  (error) => {
    const { isLoggedIn } = authStore.getState();

    // console.log("[Axios] response.error", error);
    if (error.response.status === 401 && isLoggedIn) {
      // unauthorized
      toast.error("Silahkan masuk untuk melanjutkan");
      authStore.getState().doLogout();
      //   NavigationUtils.replace('onboarding');
    } else if (error.response.status === 500) {
      // internal server error
      toast.error("[500] Internal Server Error");
    } else if (error.response.status === 404) {
      // Don't show toast for 404 errors on GET list endpoints
      // These are expected when lists are empty or routes don't exist yet
      const url = error.response.config?.url || "";
      const method = error.response.config?.method?.toLowerCase();
      const isListEndpoint =
        method === "get" &&
        (url.includes("/transaction/requests") ||
          url.endsWith("/requests") ||
          (url.includes("/requests") && !url.match(/\/requests\/[^/]+$/))); // List endpoint, not detail

      if (!isListEndpoint) {
        // Show toast for 404s on detail endpoints (not list endpoints)
        let message = error.response.data?.message;
        if (typeof message !== "string") {
          message = JSON.stringify(message);
        }
        toast.error(message);
      }
    } else {
      // response error
      let message = error.response.data?.message;
      if (typeof message !== "string") {
        message = JSON.stringify(message);
      }
      console.log({ err: error.response.config.url });
      toast.error(message);
    }

    return Promise.reject(error.response.data);
  }
);

export default axiosClient;
